<p>
  ui-infobar-top works!
</p>
